import React from 'react';
import { Crown, Scissors, Award } from 'lucide-react';

const badges = [
  {
    id: 1,
    icon: Crown,
    title: 'Atendimento Premium',
    description: 'Experiência de alto padrão do início ao fim, pensada em cada detalhe.'
  },
  {
    id: 2,
    icon: Scissors,
    title: 'Profissionais Certificados',
    description: 'Equipe especializada com técnicas modernas de corte, barba e visagismo.'
  },
  {
    id: 3,
    icon: Award,
    title: 'Ambiente Exclusivo',
    description: 'Espaço sofisticado em Jundiaí Mirim para você relaxar enquanto se cuida.'
  }
];

const TrustBadges = () => {
  return (
    <section className="py-16 bg-transparent border-y border-[#D4AF37]/20 backdrop-blur-md" data-testid="trust-badges-section">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {badges.map((badge, index) => (
            <div
              key={badge.id}
              data-testid={`trust-badge-${badge.id}`}
              className="group text-center md:text-left flex flex-col md:flex-row items-center md:items-start gap-5 p-6 rounded-sm hover:bg-black/40 transition-all duration-500"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              <div className="flex-shrink-0 w-16 h-16 rounded-full bg-[#D4AF37]/10 border border-[#D4AF37]/30 flex items-center justify-center group-hover:bg-[#D4AF37] group-hover:scale-110 transition-all duration-500">
                <badge.icon className="h-7 w-7 text-[#D4AF37] group-hover:text-black transition-colors duration-500" />
              </div>
              <div>
                <h3 className="text-white text-xl font-bold mb-2 tracking-wide">{badge.title}</h3>
                <p className="text-gray-400 leading-relaxed">{badge.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
